export interface AlertButton {
  text: string;
  role?: string;
  cssClass?: string | string[];
  handler?: (value: unknown) =>
    | boolean
    | void
    | {
        [key: string]: unknown;
      };
}

export interface AlertInput {
  type?: string;
  name?: string;
  placeholder?: string;
  value?: unknown;
  disabled?: boolean;
  min?: string | number;
  max?: string | number;
}

export type AlertButtonFill = 'clear' | 'outline' | 'solid';

export interface AlertOptions {
  header?: string;
  message?: string;
  inputs?: Array<AlertInput>;
  buttons?: Array<AlertButton | string>;
  buttonFill?: AlertButtonFill;
  values?: { [name: string]: unknown };
}

export interface AlertValues {
  [key: string | number]: unknown;
}

export interface AlertCloseEventDetail {
  data?: {
    values: AlertValues;
  };
  role?: string;
}
